import { RegionSelectionConstants } from "../../redux_constants/region_selection.constant"

export const scanOutputFormat = {
    JPG: "JPG", 
    PNG: "PNG"
}

export class Slot {
    constructor(defaultConfig) {
        this.status = RegionSelectionConstants.NOT_STARTED;
        this.speed = defaultConfig.scanSpeed;
        this.doTilingOnly = defaultConfig.doTilingOnly;
        this.doTilingAfterScan = defaultConfig.doTilingAfterScan;
        this.specimenType = defaultConfig.specimenType;
        this.objectiveType = defaultConfig.objectiveType;
        this.scanOutputFormat = defaultConfig.scanOutputFormat;
        this.slideName = "";
        this.actualRegion = [-1, -1, -1, -1];
        this.zStackLevels = 10;
        this.stepSize = 1;
        this.actionOngoing = false;
        this.message = "";
        this.autoThresholdLevel = 1;
        this.scanningProfile = "";
    }
}